<template>
    <div class='ba-card'>
        <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100'>
            <span class='ba-title'>{{ $t("ct-general-settings") }}</span>
        </div>
        <hr class='ba-hr-row'>
        <div class='ba-content ba-w-100'>
            <div class="container-accordion-form ba-grid ba-gp-1" id="accordion">
                <div v-for="(item, index) in items" :key="index" class="container-accordion-form ">
                    <div class="card ba-w-100">
                        <div class="card-header" :id="item.id" @click="show = item.id"  :class="{'collapsed':!item.expanded}" data-toggle="collapse" :data-target="`#collapse-${item.id}`"
                        :aria-expanded="item.expanded" :aria-controls="`collapse-${item.id}`">
                            <span class="py-1 d-block ba-text-14 ba-montserrat-600">{{ $t(item.name) }}
                                <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                            </span>
                        </div>
                        <div :id="`collapse-${item.id}`" :aria-labelledby="`${item.id}`" class="collapse" :class="{ 'show': item.expanded }"
                            data-parent="#accordion">
                            <div class="card-body ba-w-100">
                                <component :is="index" v-if="show == item.id"  />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SiteSettings from '../pages/SiteSettings.vue';
import WebsiteScripts from './WebsiteScripts.vue';
import WebsiteSEO from './WebsiteSEO.vue';

export default {
    components: {
        SiteSettings,
        WebsiteScripts,
        WebsiteSEO
    },
    data() {
        return {
            items: {
                SiteSettings: { id: 'site-settings', name: 'ct-website-settings', expanded: true },
                WebsiteScripts: { id: 'website-scripts', name: 'ct-script-settings', expanded: false },
                WebsiteSEO: { id: 'website-seo', name: 'ct-seo-settings', expanded: false },
            },
            show: 'site-settings'
        }
    }
}
</script>

<style lang="sass" scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/views/GeneralSettings.vue